const textToBold = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\textbf{" + selectedtext + "}"
    );
};
const textToItalics = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();

    ace.current.editor.session.replace(
        selectedrange,
        "\\textit{" + selectedtext + "}"
    );
};
const toLowerCase = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();
    ace.current.editor.session.replace(
        selectedrange,
        selectedtext.toLowerCase()
    );
};
const noBreak = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();
    ace.current.editor.session.replace(
        selectedrange,
        `\\nobreak{${selectedtext}}`
    );
};
const hBox = (ace) => {
    var selectedrange = ace.current.editor.getSelectionRange();
    let selectedtext = ace.current.editor.getSelectedText();
    ace.current.editor.session.replace(
        selectedrange,
        `\\hbox{${selectedtext}}`
    );
};

// const envi = (ace) => {
//     var selectedrange = ace.current.editor.getSelectionRange();
//     let selectedtext = ace.current.editor.getSelectedText();
//     ace.current.editor.session.replace(
//         selectedrange,
//         `\\begin{}}`
//     );
// };




const customshortcuts = (num, ace) => {
    let current = JSON.parse(localStorage.getItem("shortcuts"));

    var cursorPosition = ace.current.editor.getCursorPosition();
    if (num === 1) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut1);
    } else if (num === 2) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut2);
    } else if (num === 3) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut3);
    } else if (num === 4) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut4);
    } else if (num === 5) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut5);
    } else if (num === 6) {
        ace.current.editor.session.insert(cursorPosition, current.shortcut6);
    }
    return true;
};


export {
    textToBold,
    textToItalics,
    toLowerCase,
    noBreak,
    hBox,
    customshortcuts
}